<script setup lang="ts">

import StarRating from 'vue-star-rating'
import {ref} from "vue";
import ReviewForm from "../Form/ReviewForm.vue";
import type {ProductResponse} from "../../../responses/ProductResponse";
import type {DebtorContactResponse} from "../../../responses/Site/DebtorContactResponse";
import {label} from "../../mixins/translations";
interface Props{
    product: ProductResponse
    recaptchaKey: string
    user?: DebtorContactResponse
}
const props = defineProps<Props>();
const showForm = ref(false);
</script>

<template>
    <div class="w-full">
        <div class="flex justify-between">
            <div class="justify-start flex">
                <span v-if="!product.reviews.length">{{ label('site.review.none_found') }}</span>
            </div>
            <div class="items-end justify-end flex">
                <a class="w-auto py-2 px-4 bg-primary hover:bg-primary-700 text-white text-sm font-medium text-center cursor-pointer" @click.prevent="showForm = !showForm">
                    <span v-if="!showForm">{{ label('site.review.write') }}</span>
                    <span v-else>{{ label('site.review.hide') }}</span>
                </a>
            </div>
        </div>

        <review-form :user="user" :product-id="product.id" :recaptcha-key="recaptchaKey" v-show="showForm"></review-form>

        <div>
            <div v-for="review in product.reviews" >
                <div class="mt-2">
                    <div>
                        <star-rating
                            :increment="0.5"
                            :rating="review.stars"
                            :read-only="true"
                            :star-size="15"
                            :show-rating="false"
                        ></star-rating>
                    </div>
                    <div class="w-full mt-1">
                        <span class="font-bold">{{ review.name }}</span>
                        <span> ({{ review.created_at }})</span>
                    </div>
                    <div class="w-full italic mt-1" v-text="review.title"></div>
                    <div class="w-full mt-1" v-html="review.content"></div>
                </div>
                <div v-if="review.response" class="ml-16 bg-gray-100 p-4 mt-6 mb-10 border border-gray-300 rounded-none">
                    <div class="w-full">
                        <span class="font-bold">Nenko</span>
                        <span> ({{ review.created_at }})</span>
                    </div>
                    <div class="w-full mt-1" v-html="review.response"></div>
                </div>
            </div>
        </div>
    </div>
</template>
